import useBasicStores from '../hooks/useBasicStores';
import { RootStore as InternalRootStore } from './RootStore';

export * from './RootStore';
export * from './UserStore';
export * from './UserApi';
export * from './AuthStore';
export * from './LotStore';
export * from './singleLotStore';
export * from './messageStore';
export * from './LocationStore';
export * from './ModalStore';
export * from './ThemeStore';
export * from './SubscriptionStore';
export * from './SingleSubscriptionStore';
export * from './AdminStore';
export * from './CharityBannerStore';

export { SpinnerStore } from './SpinnerStore';
export const useStores = (): InternalRootStore => useBasicStores<InternalRootStore>();
